// extracted by css-extract-rspack-plugin
export default {"dropdownContainer":"dropdownContainer-VZiLl9","trigger":"trigger-AIKfDX","triggerText":"triggerText-vh_qbS","flag":"flag-QEPZJM"};